export const listConstant = {
  childHeader: 'SPC',
  addButtonLable: 'New SPC',
  datePickerLabel: 'Search By Year',
  modalTile: 'CREATE NEW SPC',
};

export const createConstant = {
  childHeader: 'SPC PLAN',
  theadHeader: 'SPC PLAN',
  extracolSpan: 5,
};

export const checkListList = {
  childHeader: 'SPC PLAN STATUS',
  addButtonLable: '',
  datePickerLabel: 'Search By Year',
  modalTile: 'UPDATE STATUS',
};

export const apiConstant = {
  deleteurl: 'spcPlan',
  gettableDataurl: 'spcPlan/monthly',
  getPlanByid: 'spcPlan',
  createPlanByid: 'spcPlan',
  updatePlanByid: 'spcPlan',
  sync: 'spcPlan/handleSync',
  getAllCheckList: 'spcPlan/getAllCheckList',
  checkListStatus: 'spcPlan/handleStatus',
  checklistUpload: 'spcPlan/handleUpload',
  checklistDeleteImage: 'spcPlan/handleDeleteImage',
};

export const navigationConstant = {
  createPlanSchedule: '/common/spcPlanCreate',
};
